import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid-pro'
import { FileCopy } from '@mui/icons-material'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

function CloneButton({ id }: GridRowParams) {
  const navigate = useNavigate()
  return (
    <GridActionsCellItem
      icon={<FileCopy />}
      label="Clone"
      onClick={() => navigate(`../screen/${id}/clone`)}
    />
  )
}

export default CloneButton
